import * as THREE from 'three';
import gsap from 'gsap';

export const setLoadingManager = (
    loadingRef,
    loadingAnimationLoopRef,
    onStart = null,
    onLoad = null,
    onProgress = null) => {
    const loadingManager = new THREE.LoadingManager();

    loadingManager.onStart = () => {
        // console.log('loading started...');
        ShowLoading();

        // `onStart`가 `null` 또는 `undefined`가 아닐 때만 실행
        if (typeof onStart === 'function') {
            onStart();
        }
    };

    loadingManager.onLoad = () => {
        // console.log('load complete !');
        HideLoading();

        // `onLoad`가 `null` 또는 `undefined`가 아닐 때만 실행
        if (typeof onLoad === 'function') {
            onLoad();
        }
    };

    loadingManager.onProgress = () => {
        // console.log('loading...');

        // `onProgress`가 `null` 또는 `undefined`가 아닐 때만 실행
        if (typeof onProgress === 'function') {
            onProgress();
        }
    };
    loadingManager.onError = () => {
        // console.log('errrrrrrrrrrrrrrror');
    }

    const ShowLoading = () => {
        if (loadingRef.current) {
            gsap.to(loadingRef.current, {
                opacity: 1,
                duration: 0.3,
                ease: 'linear'
            })
            SetLoadingAnimationLoop();
        }
    }

    const HideLoading = () => {
        gsap.to(loadingRef.current, {
            opacity: 0,
            duration: 1,
            ease: 'linear',
            onComplete: () => {
                if (loadingRef.current) {
                    loadingRef.current.remove();
                    loadingRef.current = null;
                }
            }
        })
    }

    const SetLoadingAnimationLoop = () => {
        if (loadingAnimationLoopRef.current) {
            let loopLoaded = false;

            loadingAnimationLoopRef.current.addEventListener('canplaythrough', () => {
                loopLoaded = true;
                // checkAndStartIntro();
                loadingAnimationLoopRef.current.play();
            }, { once: true });
        }
    };

    return loadingManager;
}

export const SetLoading = (loadingRef, loadingRateRef, progress) => {
    if (loadingRef.current && loadingRateRef.current) {
        loadingRateRef.current.innerText = `${Math.trunc(progress)}`;

        // 로고 애니메이션 제어
        // const logo = loadingRef.current.querySelector('.loading-logo svg');
        // if (logo) {
        //     const percentage = progress / 100;
        //     const maskValue = `linear-gradient(to right, black 0%, black ${percentage * 100}%, transparent ${percentage * 100}%)`;
        //     logo.style.mask = maskValue;
        //     logo.style.webkitMask = maskValue;
        //     logo.style.maskImage = maskValue;
        //     logo.style.webkitMaskImage = maskValue;
        // }
    }
}